import React from 'react';
import { Sprout, ClipboardCheck, Package, Ship } from 'lucide-react';
import { process } from '../data/mock';

const iconMap = {
  '01': Sprout,
  '02': ClipboardCheck,
  '03': Package,
  '04': Ship
};

const Process = () => {
  return (
    <section id="process" className="py-20 bg-gradient-to-b from-amber-50/30 to-white">
      <div className="max-w-7xl mx-auto px-4 sm:px-6 lg:px-8">
        {/* Section Header */}
        <div className="text-center mb-16">
          <span className="text-orange-500 font-semibold text-sm uppercase tracking-wider">Our Process</span>
          <h2 className="text-4xl md:text-5xl font-bold text-amber-950 mt-3 mb-4">
            From Farm to Your Doorstep
          </h2>
          <p className="text-gray-600 text-lg max-w-3xl mx-auto">
            Our streamlined process ensures quality, transparency, and timely delivery at every stage.
          </p>
        </div>

        {/* Process Steps */}
        <div className="relative">
          {/* Connection Line - Desktop */}
          <div className="hidden lg:block absolute top-24 left-0 right-0 h-1 bg-gradient-to-r from-green-200 via-green-400 to-green-600" style={{ top: '6rem' }}></div>

          <div className="grid md:grid-cols-2 lg:grid-cols-4 gap-8 relative">
            {process.map((step, index) => {
              const Icon = iconMap[step.step];
              return (
                <div key={index} className="relative">
                  {/* Step Card */}
                  <div className="bg-white rounded-2xl p-8 shadow-md hover:shadow-xl transition-all duration-300 border border-gray-100 h-full">
                    {/* Step Number & Icon */}
                    <div className="flex items-center justify-between mb-6">
                      <div className="text-6xl font-bold text-green-100">{step.step}</div>
                      <div className="w-16 h-16 bg-green-700 rounded-xl flex items-center justify-center shadow-lg">
                        <Icon className="text-white" size={32} />
                      </div>
                    </div>

                    {/* Content */}
                    <h3 className="text-2xl font-bold text-amber-950 mb-4">{step.title}</h3>
                    <p className="text-gray-600 leading-relaxed">{step.description}</p>
                  </div>

                  {/* Mobile Connection Line */}
                  {index < process.length - 1 && (
                    <div className="lg:hidden flex justify-center my-4">
                      <div className="w-1 h-8 bg-gradient-to-b from-green-400 to-green-600"></div>
                    </div>
                  )}
                </div>
              );
            })}
          </div>
        </div>

        {/* Quality Assurance Banner */}
        <div className="mt-20 bg-gradient-to-r from-amber-50 to-green-50 rounded-2xl p-10 border-2 border-green-200">
          <div className="flex flex-col md:flex-row items-center justify-between gap-6">
            <div className="flex-1">
              <h3 className="text-2xl font-bold text-amber-950 mb-3">Quality You Can Trust</h3>
              <p className="text-gray-700 text-lg">
                Every product undergoes rigorous quality testing and meets international food safety standards.
              </p>
            </div>
            <button 
              onClick={() => {
                const element = document.querySelector('#contact');
                if (element) element.scrollIntoView({ behavior: 'smooth' });
              }}
              className="bg-green-700 hover:bg-green-800 text-white px-8 py-4 rounded-lg font-semibold transition-all duration-300 shadow-md hover:shadow-lg whitespace-nowrap"
            >
              Start Your Order
            </button>
          </div>
        </div>
      </div>
    </section>
  );
};

export default Process;
